import { combineReducers } from 'redux';
import { createReducer } from 'typesafe-actions';
import { RequestStatus } from 'types/transport';
import { BankTransactionHandleAction } from './actions';
import { TransactionHandleAction } from '../actions';

const statusReducer = createReducer<RequestStatus>(RequestStatus.None)
  .handleType(BankTransactionHandleAction.ArchiveRequest, () => RequestStatus.Creating)
  .handleType(BankTransactionHandleAction.ArchiveResponse, () => RequestStatus.Success)
  .handleType(BankTransactionHandleAction.Error, () => RequestStatus.Error)
  .handleType(BankTransactionHandleAction.RestoreRequest, () => RequestStatus.Creating)
  .handleType(BankTransactionHandleAction.RestoreResponse, () => RequestStatus.Success)
  .handleType(TransactionHandleAction.MatchRequest, () => RequestStatus.Creating)
  .handleType(TransactionHandleAction.MatchResponse, () => RequestStatus.Success)
  .handleType(TransactionHandleAction.UnmatchRequest, () => RequestStatus.Creating)
  .handleType(TransactionHandleAction.UnmatchResponse, () => RequestStatus.Success);

export default combineReducers({
  status: statusReducer,
});
